<div class="wizard-step">
    <h2 class="step-title">Paso 6: Capacidades</h2>
    <p class="step-description">Configura inventario, cupos y reglas de aprobación.</p>

    @if(!isReadonly && errors && errors.length) {
    <div class="alert alert-danger" role="alert" aria-live="assertive">
        <strong>Corrige lo siguiente:</strong>
        <ul class="mb-0">
            <li *ngFor="let e of errors">{{ e }}</li>
        </ul>
    </div>
    }

    @if(!isReadonly && functionalType === FunctionalType.Product) {
    <div class="alert alert-info" role="note">
        Para <strong>productos</strong>, el <em>inventario</em> es obligatorio: habilita “Inventario”,
        define un <em>Stock inicial</em> ≥ 0 y ajusta si se permite <em>sobreventa</em>.
    </div>
    }

    @if(!isReadonly && functionalType === FunctionalType.Course) {
    <div class="alert alert-info" role="note">
        Para <strong>cursos</strong>, los <em>cupos</em> son obligatorios: habilita “Cupos”, define “Capacidad total”
        &gt; 0 y “Tiempo límite de reserva” ≥ 1.
    </div>
    }

    <div class="section">
        <div class="section-header">
            <h3 class="section-title">Inventario</h3>

            @if(!isReadonly) {
            <label class="toggle-container h44">
                <input type="checkbox" [(ngModel)]="inventoryEnabled" (change)="toggleInventory()" />
                <span class="toggle-slider"></span>
            </label>
            }
        </div>

        @if(!isReadonly && inventoryEnabled) {
        <div class="field-row">
            <div class="field-group">
                <label class="field-label" for="initialStock">Stock inicial</label>
                <input id="initialStock" class="field-input" type="number" min="0" step="1" [ngModel]="initialStock"
                    (ngModelChange)="onInitialStockChange($event)" placeholder="Ej. 100" inputmode="numeric" />
            </div>

            <div class="field-group">
                <label class="field-label-inline">
                    Permitir sobreventa
                </label>
                <label class="toggle-container h44">
                    <input type="checkbox" [(ngModel)]="allowOversell" (change)="updateData()" />
                    <span class="toggle-slider"></span>
                </label>
            </div>
        </div>
        }

        @if(isReadonly && inventoryEnabled) {
        <div class="readonly-card">
            <p><strong>Stock inicial:</strong> {{ initialStock }}</p>
            <p><strong>Sobreventa:</strong> {{ allowOversell ? 'Permitida' : 'No permitida' }}</p>
        </div>
        }
    </div>

    <!-- Cupos -->
    <div class="section">
        <div class="section-header">
            <h3 class="section-title">Cupos</h3>

            @if(!isReadonly) {
            <label class="toggle-container h44">
                <input type="checkbox" [(ngModel)]="seatsEnabled" (change)="toggleQuotas()" />
                <span class="toggle-slider"></span>
            </label>
            }
        </div>

        @if(!isReadonly && seatsEnabled) {
        <div class="quota-fields">
            <div class="field-row">
                <div class="field-group">
                    <label class="field-label" for="totalSeats">Capacidad total</label>
                    <input id="totalSeats" class="field-input" type="number" min="0" step="1" [ngModel]="totalSeats"
                        (ngModelChange)="onTotalCapacityChange($event)" placeholder="Ej. 50" inputmode="numeric" />
                </div>

                <div class="field-group">
                    <label class="field-label-inline" for="holdTTL">
                        Tiempo límite de reserva (min)
                    </label>
                    <input id="holdTTL" class="field-input" type="number" min="1" step="1" [ngModel]="holdTTLMinutes"
                        (ngModelChange)="onReserveTTLChange($event)" placeholder="10" inputmode="numeric" />
                </div>
            </div>
        </div>
        }

        @if(isReadonly && seatsEnabled) {
        <div class="readonly-card">
            <p><strong>Capacidad total:</strong> {{ totalSeats }}</p>
            <p><strong>Tiempo límite de reserva:</strong> {{ holdTTLMinutes }} min</p>
        </div>
        }
    </div>

    <div class="section">
        <div class="section-header">
            <h3 class="section-title">Aprobación</h3>

            @if(!isReadonly) {
            <label class="toggle-container h44">
                <input type="checkbox" [(ngModel)]="preApprovalRequired" (change)="toggleApproval()" />
                <span class="toggle-slider"></span>
            </label>
            }
        </div>

        @if(!isReadonly && preApprovalRequired) {
        <div class="quota-fields">
            <div class="field-row">
                <div class="field-group">
                    <label class="field-label-inline" for="paymentWindow">
                        Tiempo límite de pago (min)
                    </label>
                    <input id="paymentWindow" class="field-input" type="number" min="5" step="1"
                        [ngModel]="paymentWindowMinutes" (ngModelChange)="onPaymentWindowChange($event)"
                        placeholder="60" inputmode="numeric" />
                </div>
            </div>
        </div>
        }

        @if(isReadonly && preApprovalRequired) {
        <div class="readonly-card">
            <p><strong>Tiempo límite de pago:</strong> {{ paymentWindowMinutes }} min</p>
        </div>
        }
    </div>
</div>